//
//  SDKExporterCustomBlockProperty.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
export var ExporterCustomBlockPropertyType;
(function (ExporterCustomBlockPropertyType) {
    ExporterCustomBlockPropertyType["string"] = "string";
    ExporterCustomBlockPropertyType["number"] = "number";
    ExporterCustomBlockPropertyType["boolean"] = "boolean";
    ExporterCustomBlockPropertyType["enum"] = "enum";
    ExporterCustomBlockPropertyType["image"] = "image";
    ExporterCustomBlockPropertyType["color"] = "color";
    ExporterCustomBlockPropertyType["typography"] = "typography";
})(ExporterCustomBlockPropertyType || (ExporterCustomBlockPropertyType = {}));
export var ExporterCustomBlockPropertyInputType;
(function (ExporterCustomBlockPropertyInputType) {
    ExporterCustomBlockPropertyInputType["plain"] = "plain";
    ExporterCustomBlockPropertyInputType["code"] = "code";
})(ExporterCustomBlockPropertyInputType || (ExporterCustomBlockPropertyInputType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ExporterCustomBlockProperty {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(data) {
        var _a, _b, _c;
        this.label = data.label;
        this.key = data.key;
        this.type = data.type;
        this.inputType =
            (_a = data.inputType) !== null && _a !== void 0 ? _a : ExporterCustomBlockPropertyInputType.plain;
        this.isMultiline = data.isMultiline;
        this.default = (_b = data.default) !== null && _b !== void 0 ? _b : null;
        this.values = (_c = data.values) !== null && _c !== void 0 ? _c : [];
    }
}
